import { render, staticRenderFns } from "./GlobalRating.vue?vue&type=template&id=1b2ae4a3&scoped=true&"
import script from "./GlobalRating.vue?vue&type=script&lang=js&"
export * from "./GlobalRating.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRating.vue?vue&type=style&index=0&id=1b2ae4a3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ae4a3",
  null
  
)

export default component.exports